/**
 * Dashboard
 *
 */
import React from 'react'
import { connect } from 'react-redux'
import { DatePicker } from 'antd'
import moment from 'moment'
import Page from '../components/View'
import Api from '../Api'
import { Divider } from '../components'
import Exception from '../Exception'
import { TarjetasResumen } from './Kernel/Dashboard/TarjetasResumen'

class Dashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      desde: moment().utc().startOf('month'),
      hasta: moment().utc().endOf('month'),
      movimientos: [],
    }
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    const fecha = moment().utc()
    this.fetch(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * fetch
   */
  fetch = async (inicio, termino) => {
    try {
      this.setState({
        loading: true,
        query: { inicio, termino }
      })

      const response = await Api.query.list({
        movimientos: {
          model: 'ComProveedorMovimiento',
          attributes: [
            'iTipo',
            'dMonto',
            'dFecha',
          ],
          include: [
            { as: 'tipo', attributes: ['sDescripcion'] },
            { as: 'moneda', attributes: ['sCodigo'] },
          ],
          where: {
            iIdProveedor: Api.getProviderId(),
            iTipo: { $ne: 0 },
            $and: [
              { dFecha: { $gte: inicio } },
              { dFecha: { $lte: termino } },
            ],
          },
          order: [['iId', 'DESC']]
        }
      })

      this.setState({
        movimientos: response.data.movimientos || [],
        loading: false,
      })
    } catch (error) {
      this.setState({ loading: false })
      Exception.load(error).show()
    }
  }

  /**
   * logIconOptions
   *
   * @param {*} tipo
   */
  logIconOptions = (tipo) => {
    switch (tipo) {
      case 1:
        return {
          bg: '#ffe8c2',
          fg: '#f39937',
          icon: 'plus',
        }

      default:
        return {
          bg: '#def4f8',
          fg: '#5db9c3',
          icon: 'check',
        }
    }
  }

  /**
   * render
   */
  render() {
    const { styles, theme } = this.props

    return (
      <Page>
        <div style={{ padding: 25, flex: 1 }}>
          <div style={{ height: '20%' }}>
            <h1 style={{ marginBottom: 0 }}>Bienvenido</h1>
            <h3 style={{ marginBottom: 20, color: theme.label }}>{this.props.cuenta.sRazonSocial}</h3>

            <div>
              <label>RANGO DE CONSULTA</label>
              <br />
              <DatePicker.RangePicker
                value={[moment(this.state.desde).utc(), moment(this.state.hasta).utc()]}
                onChange={
                  (_, fechas) =>
                    this.setState({
                      desde: fechas[0].length ? fechas[0] : null,
                      hasta: fechas[1].length ? fechas[1] : null,
                    })
                }
              />
            </div>

            <Divider margin={21} />
          </div>

          <div style={styles.columnas}>
            <div style={styles.resumen}>
              <TarjetasResumen
                desde={this.state.desde}
                hasta={this.state.hasta}
              />
            </div>

            <div style={styles.movtosContainer}>
              <div style={styles.movimientos}>

              </div>
            </div>
          </div>

        </div>
      </Page>
    )
  }
}

const buildStyles = () => ({
  columnas: {
    display: 'flex',
    height: '78%',
  },

  resumen: {
    flex: '1 0 50%',
    height: '100%',
    width: '50%',
    whiteSpace: 'nowrap',
    marginRight: 12,
  },

  movtosContainer: {
    position: 'relative',
    flex: '1 0 50%',
    whiteSpace: 'nowrap',
  },

  movimientos: {
    overflowY: 'auto',
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    top: 0,
  }
})

export default connect(
  state => ({
    theme: state.theme.values,
    styles: buildStyles(state.theme.values),
    cuenta: state.cuenta,
  })
)(Dashboard)
